// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__IQiSU","mobile":"footer_mobile__Q9K+w","home":"footer_home__m8wj+","fullscreen":"footer_fullscreen__MJeKJ"};